// Generated file - do not change manually!
/**
 * Defines the growing mode, used in the <code>ui5-list</code>.
 */
export var ListGrowingMode;
(function (ListGrowingMode) {
    /**
     * Component's <code>load-more</code> is fired upon pressing a "More" button. at the bottom.
     */
    ListGrowingMode["Button"] = "Button";
    /**
     * Component's growing is not enabled.
     */
    ListGrowingMode["None"] = "None";
    /**
     * Component's <code>load-more</code> is fired upon scroll.
     */
    ListGrowingMode["Scroll"] = "Scroll";
})(ListGrowingMode || (ListGrowingMode = {}));
